"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _react = _interopRequireWildcard(require("react"));

var _RevisionOptionSubtitle = _interopRequireDefault(require("./RevisionOptionSubtitle"));

var _RevisionOptionTitle = _interopRequireDefault(require("./RevisionOptionTitle"));

var _RevisionOptionToggle = _interopRequireDefault(require("./RevisionOptionToggle"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-shrink: 1;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  padding-left: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 2px 4px 0 rgba(196, 205, 214, 0.5);\n  display: flex;\n  height: 60px;\n  justify-content: space-between;\n  padding: 4px;\n  &:not(:last-child) {\n    margin-bottom: 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var containerStyle = (0, _emotion.css)(_templateObject(), colors.white, colors.alloy);
var infoStyle = (0, _emotion.css)(_templateObject2());

var RevisionOption =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RevisionOption, _PureComponent);

  function RevisionOption() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RevisionOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RevisionOption)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onSelect = function (selected) {
      var _this$props = _this.props,
          name = _this$props.name,
          priceModelId = _this$props.priceModelId,
          revisionId = _this$props.revisionId,
          onSelect = _this$props.onSelect;

      if (selected) {
        onSelect && onSelect(priceModelId, revisionId, name);
      } else {
        onSelect && onSelect(null, null, null);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(RevisionOption, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          name = _this$props2.name,
          revisionId = _this$props2.revisionId,
          selected = _this$props2.selected,
          onSelect = _this$props2.onSelect;
      return _react.default.createElement("div", {
        className: (0, _emotion.cx)(containerStyle, className)
      }, _react.default.createElement("div", {
        className: infoStyle
      }, _react.default.createElement(_RevisionOptionTitle.default, {
        name: name
      }), _react.default.createElement(_RevisionOptionSubtitle.default, {
        revisionId: revisionId
      })), onSelect ? _react.default.createElement(_RevisionOptionToggle.default, {
        selected: selected,
        onSelect: this.onSelect
      }) : null);
    }
  }]);
  return RevisionOption;
}(_react.PureComponent);

var _default = RevisionOption;
exports.default = _default;